import React from 'react';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useOrganizationSubscription } from 'Shared/utils/hooks/use-organization-subscription';

// Constants
import { billingStates } from 'Shared/constants/constants';

// Components
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';
import { WpButton } from 'Wpds/components/button';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import Spinner from 'Shared/components/Spinner';
import { usePartnerInfo } from 'Shared/utils/hooks/use-partner-info';

function BillingContactInfo() {
  const { isFetching, partnerInfo } = usePartnerInfo();
  const { intercomContactSalesEventName } = useApp();
  const { billingState, isFreePlan } = useOrganizationSubscription();

  const getDescription = () => {
    switch (billingState) {
      case billingStates.FREE_PLAN:
        return 'Schedule a call to learn more about billing or upgrade your plan.';
      case billingStates.PAID_PLAN:
        return 'Please contact your customer care expert, JP Baerston for billing inquiries.';
      case billingStates.PAID_PLAN_PREDICTIVEINDEX:
        return 'Please contact your consultant for all billing inquiries.';
      default:
        return '';
    }
  };

  const contactEmail = partnerInfo?.forcePartnerContactEmail || 'jbaerston@predictiveindex.com';

  if (isFetching) {
    return <Spinner activeIf />;
  }

  return (
    <EmptyStateContainer
      subTitle={getDescription()}
      inContainer
      button={
        isFreePlan ? (
          <WpButton dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>Schedule a Call</WpButton>
        ) : (
          <WpTextField
            id="billing-contact-email"
            label="Contact email"
            value={contactEmail}
            enableCopy
            disabled
            labelHidden
          />
        )
      }
    />
  );
}

export default BillingContactInfo;
